import React from 'react';
import cn from 'classnames';
import fromExponential from 'from-exponential';
import { AssetAmountInfoType } from 'services/requests';

import styles from './CryptoAmount.module.css';

type CryptoAmountProps = {
  asset: AssetAmountInfoType;
};

const CryptoAmount: React.FC<CryptoAmountProps> = ({ asset }) => {
  const formatted = `${fromExponential(asset.amount)} ${asset.code}`;

  return (
    <span className={cn([asset.amount > 0 && styles.green])}>
      {asset.amount > 0 && '+'}
      {formatted}
    </span>
  );
};

export default CryptoAmount;
